import { compose, pick } from 'ramda'
import { isNilOrEmpty, omitBy } from 'ramda-adjunct'
import apiClient from '../../lib/util/api-client'

const service = apiClient.service('uploads')

const omitEmpty = omitBy(isNilOrEmpty)
const createParams = compose(omitEmpty, pick(['type', 'path', 'upload_preset', 'public_id']))

export default () => ({
  state: {},
  sequences: {
    signUpload: [
      //
      ({ props }) => service.create(createParams(props)),
    ],
  },
})
